/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SlackConnectionStatus
 */
export interface SlackConnectionStatus {
    /**
     * 
     * @type {boolean}
     * @memberof SlackConnectionStatus
     */
    ok: boolean;
    /**
     * 
     * @type {string}
     * @memberof SlackConnectionStatus
     */
    team: string;
    /**
     * 
     * @type {string}
     * @memberof SlackConnectionStatus
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof SlackConnectionStatus
     */
    url: string;
}

export function SlackConnectionStatusFromJSON(json: any): SlackConnectionStatus {
    return SlackConnectionStatusFromJSONTyped(json, false);
}

export function SlackConnectionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlackConnectionStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ok': json['ok'],
        'team': json['team'],
        'user': json['user'],
        'url': json['url'],
    };
}

export function SlackConnectionStatusToJSON(value?: SlackConnectionStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ok': value.ok,
        'team': value.team,
        'user': value.user,
        'url': value.url,
    };
}


